var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTickDarkGreenButtonFullIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#EAECEF",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 16C20.48 16 16 20.48 16 26C16 31.52 20.48 36 26 36C31.52 36 36 31.52 36 26C36 20.48 31.52 16 26 16ZM23.29 30.29L19.7 26.7C19.31 26.31 19.31 25.68 19.7 25.29C20.09 24.9 20.72 24.9 21.11 25.29L24 28.17L30.88 21.29C31.27 20.9 31.9 20.9 32.29 21.29C32.68 21.68 32.68 22.31 32.29 22.7L24.7 30.29C24.32 30.68 23.68 30.68 23.29 30.29Z",
    fill: "#39842B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickDarkGreenButtonFullIcon);
export default __webpack_public_path__ + "static/media/tickDarkGreenButtonFullIcon.822bf7cf2879da8e894776869386dfa1.svg";
export { ForwardRef as ReactComponent };